let originalFavicon = null;
const pendingActions = new Map(); // Changed to Map to track timestamps

const setLoadingFavicon = () => {
    if (!originalFavicon) {
        originalFavicon = document.querySelector("link[rel*='icon']")?.href;
    }

    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';

    const canvas = document.createElement('canvas');
    canvas.width = 16;
    canvas.height = 16;
    const ctx = canvas.getContext('2d');

    let rotation = 0;
    let lastTimestamp = 0;
    const animate = (timestamp) => {
        if (pendingActions.size > 0) {
            // Limit frame updates for smoother animation
            if (timestamp - lastTimestamp > 33) { // ~60 FPS
                lastTimestamp = timestamp;

                ctx.clearRect(0, 0, 16, 16);

                // Draw background track line
                ctx.beginPath();
                ctx.strokeStyle = '#393939';
                ctx.lineWidth = 2.5;
                ctx.lineCap = 'round';
                ctx.arc(8, 8, 5, 0, 2 * Math.PI);
                ctx.stroke();

                ctx.save();
                ctx.translate(8, 8);
                ctx.rotate(rotation);

                // Draw spinner with thicker line
                ctx.beginPath();
                ctx.strokeStyle = '#000';
                ctx.lineWidth = 2;
                ctx.lineCap = 'round';
                ctx.arc(0, 0, 5, 0, 0.7 * Math.PI);
                ctx.stroke();
                ctx.restore();

                rotation += 0.25; // Increased rotation speed
                link.href = canvas.toDataURL();
            }
            requestAnimationFrame(animate);
        }
    };

    requestAnimationFrame(animate);
};

const restoreFavicon = () => {
    // Clear any stale pending actions (older than 30 seconds)
    const now = Date.now();
    for (const [action, timestamp] of pendingActions) {
        if (now - timestamp > 30000) { // 30 seconds timeout
            pendingActions.delete(action);
        }
    }

    if (pendingActions.size === 0 && originalFavicon) {
        const link = document.querySelector("link[rel*='icon']");
        if (link) {
            link.href = originalFavicon;
        }
    }
};

export const loadingMiddleware = () => (next) => (action) => {
    if (action.type?.endsWith('/pending')) {
        pendingActions.set(action.type, Date.now());
        setLoadingFavicon();
    }

    if (action.type?.endsWith('/fulfilled') || action.type?.endsWith('/rejected')) {
        const baseActionType = action.type.replace(/(\/fulfilled|\/rejected)$/, '/pending');
        pendingActions.delete(baseActionType);

        // Immediate check for any remaining pending actions
        if (pendingActions.size === 0) {
            setTimeout(() => {
                // Double check if still no pending actions before restoring
                if (pendingActions.size === 0) {
                    restoreFavicon();
                }
            }, 300);
        }
    }

    return next(action);
};